import React from 'react';
import { BaseBox } from '@docon/docon-ui-library';
import styled from 'styled-components';

interface IProps {
  [key: string]: any;
  style?: any;
}

const Svg = styled(BaseBox)``;

const IconBase = ({ style = {}, ...props }: IProps) => (
  <Svg
    as='svg'
    aria-hidden='true'
    focusable='false'
    role='img'
    fill='currentColor'
    preserveAspectRatio='xMidYMid meet'
    {...props}
    style={{
      ...style,
    }}
  />
);

export default IconBase;